$(document).ready(function () {
  // Increment button click
  $('body').on('click', '.list-increment-btn', function () {
    var productId = $(this).data('product-id');
    var qtyInput = $('.list-qty-default[data-product-id="' + productId + '"]');
    var stockQuantity = parseInt(qtyInput.data('stock-quantity'));
    var currentQTY = parseInt(qtyInput.val());

    if (currentQTY < stockQuantity) {
      currentQTY++;
      qtyInput.val(currentQTY);
      $('.list-selqty[data-product-id="' + productId + '"]').val(currentQTY);
    }

    if (currentQTY >= stockQuantity) {
      $(this).prop("disabled", true);
    }
  });

  // Decrement button click
  $('body').on('click', '.list-decrement-btn', function () {
    var productId = $(this).data('product-id');
    var qtyInput = $('.list-qty-default[data-product-id="' + productId + '"]');
    var currentQTY = parseInt(qtyInput.val());
    var stockQuantity = parseInt(qtyInput.data('stock-quantity'));

    if (currentQTY > 1) {
      currentQTY--;
      qtyInput.val(currentQTY);
      $('.list-selqty[data-product-id="' + productId + '"]').val(currentQTY);
    }

    if (currentQTY < stockQuantity) {
      $('.list-increment-btn[data-product-id="' + productId + '"]').prop("disabled", false);
    }
  });

  // Manual input validation
  $('body').on('input', '.list-qty-default', function () {
    var productId = $(this).data('product-id');
    var stockQuantity = parseInt($(this).data('stock-quantity'));
    var enteredQty = parseInt($(this).val());

    if (enteredQty > stockQuantity) {
      $(this).val(stockQuantity);
      $('.list-selqty[data-product-id="' + productId + '"]').val(stockQuantity);
      $('.list-increment-btn[data-product-id="' + productId + '"]').prop("disabled", true);
    } else if (enteredQty < 1 || isNaN(enteredQty)) {
      $(this).val(1);
      $('.list-selqty[data-product-id="' + productId + '"]').val(1);
    } else {
      $('.list-selqty[data-product-id="' + productId + '"]').val(enteredQty);
      $('.list-increment-btn[data-product-id="' + productId + '"]').prop("disabled", false);
    }
  });

  // Add to Cart AJAX
  $('body').on('click', '.list-add-to-cart-btn', function () {
    const button = $(this);
    const variantId = button.data('variant-id');
    const productId = button.data('product-id');
    const qtyInput = $('.list-qty-default[data-product-id="' + productId + '"]');
    const stockQuantity = parseInt(qtyInput.data('stock-quantity'));
    let quantity = parseInt($('.list-selqty[data-product-id="' + productId + '"]').val()) || 1;

    if (quantity > stockQuantity) {
      alert("You can only add up to " + stockQuantity + " items");
      quantity = stockQuantity;
      qtyInput.val(quantity);
      $('.list-selqty[data-product-id="' + productId + '"]').val(quantity);
      return;
    }

    button.prop('disabled', true).text('Adding...');

    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: {
        id: variantId,
        quantity: quantity,
      },
      success: function (response) {
        const addedProduct = {
          name: response.title,
          price: (response.price / 100).toFixed(2),
          image: response.image,
          variantId: variantId,
          productId: productId,
          stockQuantity: stockQuantity // ✅ FIX: pass stock to popup
        };

        $.ajax({
          url: '/cart.js',
          type: 'GET',
          dataType: 'json',
          success: function (cart) {
            const totalItems = cart.item_count;
            const cartTotal = (cart.total_price / 100).toFixed(2);

            showProductPopup(addedProduct, totalItems, cartTotal);

            $('cart-counter').text(totalItems).removeAttr('hidden');
            $('cart-total').text(`AED ${cartTotal}`);
          },
          error: function () {
            console.error('Error fetching cart details');
          },
        });

        button.prop('disabled', false).html('<img src="https://cdn.shopify.com/s/files/1/0722/8509/4126/t/3/assets/cart-add.svg?v=1738259599" alt="store icon" width="24" height="24"/>');
      },
      error: function (xhr) {
        alert('Error adding item to cart: ' + xhr.responseJSON.description);
        button.prop('disabled', false).html('<img src="https://cdn.shopify.com/s/files/1/0722/8509/4126/t/3/assets/cart-add.svg?v=1738259599" alt="store icon" width="24" height="24"/>');
      },
    });
  });

  // Popup
  function showProductPopup(product, totalItems, cartTotal) {
    let popupHtml = `
      <div class="list-success-popup">
        <div class="popup-header">
          <button class="list-close-popup">×</button>
        </div>
        <div class="popup-body">
          <img src="${product.image}" alt="${product.name}" class="popup-product-image">
          <div class="product-desc">
            <div class="cart-success-title">
              <i class="fa fa-check-circle" aria-hidden="true"></i>
              <span>Added to cart!</span>
            </div>
            <strong>${product.name}</strong>
          </div>
          <div class="cart-totals">
            <p><span>${totalItems} Items</span> <span>|</span><span>AED ${cartTotal}</span></p>
            <div class="quantity-control">
              <button class="list-decrement-btn" data-product-id="${product.productId}">-</button>
              <input type="number" class="list-qty-default quantity"
                data-product-id="${product.productId}"
                value="1" min="1"
                data-stock-quantity="${product.stockQuantity}" />
              <button class="list-increment-btn"
                data-product-id="${product.productId}"
                ${1 >= product.stockQuantity ? 'disabled' : ''}>+</button>
            </div>
            <button type="button" class="list-add-to-cart-btn list-selqty"
              data-product-id="${product.productId}"
              data-variant-id="${product.variantId}">
              <img src="https://cdn.shopify.com/s/files/1/0722/8509/4126/t/3/assets/cart-add.svg?v=1738259599" alt="store icon" width="24" height="24"/>
            </button>
            <button class="checkout-btn" onclick="window.location.href='/checkout'">Checkout</button>
            <button class="view-cart-btn" onclick="window.location.href='/cart'"><i class="fa fa-shopping-cart" aria-hidden="true"></i> Go to Cart</button>
          </div>
        </div>
      </div>
    `;
    $('body').append(popupHtml);
  }

  // Close popup
  $(document).on('click', '.list-close-popup', function () {
    $('.list-success-popup').remove();
  });

  // PDP increment
  $('body').on('click', '.pdp-increment-btn', function () {
    var currentQTY = parseInt($(this).parent().parent().find(".pdp-qty-default").val());
    currentQTY++;
    $(this).parent().parent().find(".pdp-qty-default").val(currentQTY);
  });

  // PDP decrement
  $('body').on('click', '.pdp-decrement-btn', function () {
    var currentQTY = parseInt($(this).parent().parent().find(".pdp-qty-default").val());
    currentQTY--;
    if (currentQTY > 0) {
      $(this).parent().parent().find(".pdp-qty-default").val(currentQTY);
    }
  });
});
